export default __webpack_public_path__ + "static/media/front.4d2e64f5.png";